import sso from './sso';
import licenseLimit from './license-limit';
import auditLogs from './audit-logs';
import reviewWorkflows from './review-workflows';

export default {
  sso,
  'license-limit': licenseLimit,
  'audit-logs': auditLogs,
  'review-workflows': reviewWorkflows,
};
